/* Auto-generated — run: npm run build:whitstable-heights-progress */

import type { ProgressCarouselItem } from '../components/ProgressStageCarousel';

export type WhitstableHeightsProgressStage = {
  date: string;
  title: string;
  items: ProgressCarouselItem[];
};

export const WHITSTABLE_HEIGHTS_PROGRESS_STAGES: WhitstableHeightsProgressStage[] = [
  {
    "date": "January 2026",
    "title": "Cut and Fill Completion",
    "items": [
      {
        "src": "/progress/whitstable-heights/05-cut-and-fill-completion/000.jpg",
        "type": "image",
        "alt": "Cut and Fill Completion, photo 1 of 10"
      },
      {
        "src": "/progress/whitstable-heights/05-cut-and-fill-completion/001.jpg",
        "type": "image",
        "alt": "Cut and Fill Completion, photo 2 of 10"
      },
      {
        "src": "/progress/whitstable-heights/05-cut-and-fill-completion/002.jpg",
        "type": "image",
        "alt": "Cut and Fill Completion, photo 3 of 10"
      },
      {
        "src": "/progress/whitstable-heights/05-cut-and-fill-completion/003.jpg",
        "type": "image",
        "alt": "Cut and Fill Completion, photo 4 of 10"
      },
      {
        "src": "/progress/whitstable-heights/05-cut-and-fill-completion/004.jpg",
        "type": "image",
        "alt": "Cut and Fill Completion, photo 5 of 10"
      },
      {
        "src": "/progress/whitstable-heights/05-cut-and-fill-completion/005.jpg",
        "type": "image",
        "alt": "Cut and Fill Completion, photo 6 of 10"
      },
      {
        "src": "/progress/whitstable-heights/05-cut-and-fill-completion/006.jpg",
        "type": "image",
        "alt": "Cut and Fill Completion, photo 7 of 10"
      },
      {
        "src": "/progress/whitstable-heights/05-cut-and-fill-completion/007.jpg",
        "type": "image",
        "alt": "Cut and Fill Completion, photo 8 of 10"
      },
      {
        "src": "/progress/whitstable-heights/05-cut-and-fill-completion/008.jpg",
        "type": "image",
        "alt": "Cut and Fill Completion, photo 9 of 10"
      },
      {
        "src": "/progress/whitstable-heights/05-cut-and-fill-completion/009.jpg",
        "type": "image",
        "alt": "Cut and Fill Completion, photo 10 of 10"
      }
    ]
  },
  {
    "date": "December 2025",
    "title": "Completion of WMP Car Park",
    "items": [
      {
        "src": "/progress/whitstable-heights/04-completion-of-wmp-car-park/000.jpg",
        "type": "image",
        "alt": "Completion of WMP Car Park, photo 1 of 8"
      },
      {
        "src": "/progress/whitstable-heights/04-completion-of-wmp-car-park/001.jpg",
        "type": "image",
        "alt": "Completion of WMP Car Park, photo 2 of 8"
      },
      {
        "src": "/progress/whitstable-heights/04-completion-of-wmp-car-park/002.jpg",
        "type": "image",
        "alt": "Completion of WMP Car Park, photo 3 of 8"
      },
      {
        "src": "/progress/whitstable-heights/04-completion-of-wmp-car-park/003.jpg",
        "type": "image",
        "alt": "Completion of WMP Car Park, photo 4 of 8"
      },
      {
        "src": "/progress/whitstable-heights/04-completion-of-wmp-car-park/004.jpg",
        "type": "image",
        "alt": "Completion of WMP Car Park, photo 5 of 8"
      },
      {
        "src": "/progress/whitstable-heights/04-completion-of-wmp-car-park/005.jpg",
        "type": "image",
        "alt": "Completion of WMP Car Park, photo 6 of 8"
      },
      {
        "src": "/progress/whitstable-heights/04-completion-of-wmp-car-park/006.jpg",
        "type": "image",
        "alt": "Completion of WMP Car Park, photo 7 of 8"
      },
      {
        "src": "/progress/whitstable-heights/04-completion-of-wmp-car-park/007.jpg",
        "type": "image",
        "alt": "Completion of WMP Car Park, photo 8 of 8"
      }
    ]
  },
  {
    "date": "October 2025",
    "title": "Site Cut and Fill",
    "items": [
      {
        "src": "/progress/whitstable-heights/03-site-cut-and-fill/000.jpg",
        "type": "image",
        "alt": "Site Cut and Fill, photo 1 of 10"
      },
      {
        "src": "/progress/whitstable-heights/03-site-cut-and-fill/001.jpg",
        "type": "image",
        "alt": "Site Cut and Fill, photo 2 of 10"
      },
      {
        "src": "/progress/whitstable-heights/03-site-cut-and-fill/002.jpg",
        "type": "image",
        "alt": "Site Cut and Fill, photo 3 of 10"
      },
      {
        "src": "/progress/whitstable-heights/03-site-cut-and-fill/003.jpg",
        "type": "image",
        "alt": "Site Cut and Fill, photo 4 of 10"
      },
      {
        "src": "/progress/whitstable-heights/03-site-cut-and-fill/004.jpg",
        "type": "image",
        "alt": "Site Cut and Fill, photo 5 of 10"
      },
      {
        "src": "/progress/whitstable-heights/03-site-cut-and-fill/005.jpg",
        "type": "image",
        "alt": "Site Cut and Fill, photo 6 of 10"
      },
      {
        "src": "/progress/whitstable-heights/03-site-cut-and-fill/006.jpg",
        "type": "image",
        "alt": "Site Cut and Fill, photo 7 of 10"
      },
      {
        "src": "/progress/whitstable-heights/03-site-cut-and-fill/007.jpg",
        "type": "image",
        "alt": "Site Cut and Fill, photo 8 of 10"
      },
      {
        "src": "/progress/whitstable-heights/03-site-cut-and-fill/008.jpg",
        "type": "image",
        "alt": "Site Cut and Fill, photo 9 of 10"
      },
      {
        "src": "/progress/whitstable-heights/03-site-cut-and-fill/009.jpg",
        "type": "image",
        "alt": "Site Cut and Fill, photo 10 of 10"
      }
    ]
  },
  {
    "date": "September 2025",
    "title": "WMP Car Park and Site Enabling",
    "items": [
      {
        "src": "/progress/whitstable-heights/02-wmp-car-park-and-site-enabling/000.jpg",
        "type": "image",
        "alt": "WMP Car Park and Site Enabling, photo 1 of 18"
      },
      {
        "src": "/progress/whitstable-heights/02-wmp-car-park-and-site-enabling/001.jpg",
        "type": "image",
        "alt": "WMP Car Park and Site Enabling, photo 2 of 18"
      },
      {
        "src": "/progress/whitstable-heights/02-wmp-car-park-and-site-enabling/002.jpg",
        "type": "image",
        "alt": "WMP Car Park and Site Enabling, photo 3 of 18"
      },
      {
        "src": "/progress/whitstable-heights/02-wmp-car-park-and-site-enabling/003.jpg",
        "type": "image",
        "alt": "WMP Car Park and Site Enabling, photo 4 of 18"
      },
      {
        "src": "/progress/whitstable-heights/02-wmp-car-park-and-site-enabling/004.jpg",
        "type": "image",
        "alt": "WMP Car Park and Site Enabling, photo 5 of 18"
      },
      {
        "src": "/progress/whitstable-heights/02-wmp-car-park-and-site-enabling/005.jpg",
        "type": "image",
        "alt": "WMP Car Park and Site Enabling, photo 6 of 18"
      },
      {
        "src": "/progress/whitstable-heights/02-wmp-car-park-and-site-enabling/006.jpg",
        "type": "image",
        "alt": "WMP Car Park and Site Enabling, photo 7 of 18"
      },
      {
        "src": "/progress/whitstable-heights/02-wmp-car-park-and-site-enabling/007.jpg",
        "type": "image",
        "alt": "WMP Car Park and Site Enabling, photo 8 of 18"
      },
      {
        "src": "/progress/whitstable-heights/02-wmp-car-park-and-site-enabling/008.jpg",
        "type": "image",
        "alt": "WMP Car Park and Site Enabling, photo 9 of 18"
      },
      {
        "src": "/progress/whitstable-heights/02-wmp-car-park-and-site-enabling/009.jpg",
        "type": "image",
        "alt": "WMP Car Park and Site Enabling, photo 10 of 18"
      },
      {
        "src": "/progress/whitstable-heights/02-wmp-car-park-and-site-enabling/010.jpg",
        "type": "image",
        "alt": "WMP Car Park and Site Enabling, photo 11 of 18"
      },
      {
        "src": "/progress/whitstable-heights/02-wmp-car-park-and-site-enabling/011.jpg",
        "type": "image",
        "alt": "WMP Car Park and Site Enabling, photo 12 of 18"
      },
      {
        "src": "/progress/whitstable-heights/02-wmp-car-park-and-site-enabling/012.jpg",
        "type": "image",
        "alt": "WMP Car Park and Site Enabling, photo 13 of 18"
      },
      {
        "src": "/progress/whitstable-heights/02-wmp-car-park-and-site-enabling/013.jpg",
        "type": "image",
        "alt": "WMP Car Park and Site Enabling, photo 14 of 18"
      },
      {
        "src": "/progress/whitstable-heights/02-wmp-car-park-and-site-enabling/014.jpg",
        "type": "image",
        "alt": "WMP Car Park and Site Enabling, photo 15 of 18"
      },
      {
        "src": "/progress/whitstable-heights/02-wmp-car-park-and-site-enabling/015.jpg",
        "type": "image",
        "alt": "WMP Car Park and Site Enabling, photo 16 of 18"
      },
      {
        "src": "/progress/whitstable-heights/02-wmp-car-park-and-site-enabling/016.jpg",
        "type": "image",
        "alt": "WMP Car Park and Site Enabling, photo 17 of 18"
      },
      {
        "src": "/progress/whitstable-heights/02-wmp-car-park-and-site-enabling/017.jpg",
        "type": "image",
        "alt": "WMP Car Park and Site Enabling, photo 18 of 18"
      }
    ]
  },
  {
    "date": "May 2025",
    "title": "Pre-Start",
    "items": [
      {
        "src": "/progress/whitstable-heights/01-pre-start/000.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 1 of 20"
      },
      {
        "src": "/progress/whitstable-heights/01-pre-start/001.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 2 of 20"
      },
      {
        "src": "/progress/whitstable-heights/01-pre-start/002.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 3 of 20"
      },
      {
        "src": "/progress/whitstable-heights/01-pre-start/003.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 4 of 20"
      },
      {
        "src": "/progress/whitstable-heights/01-pre-start/004.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 5 of 20"
      },
      {
        "src": "/progress/whitstable-heights/01-pre-start/005.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 6 of 20"
      },
      {
        "src": "/progress/whitstable-heights/01-pre-start/006.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 7 of 20"
      },
      {
        "src": "/progress/whitstable-heights/01-pre-start/007.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 8 of 20"
      },
      {
        "src": "/progress/whitstable-heights/01-pre-start/008.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 9 of 20"
      },
      {
        "src": "/progress/whitstable-heights/01-pre-start/009.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 10 of 20"
      },
      {
        "src": "/progress/whitstable-heights/01-pre-start/010.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 11 of 20"
      },
      {
        "src": "/progress/whitstable-heights/01-pre-start/011.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 12 of 20"
      },
      {
        "src": "/progress/whitstable-heights/01-pre-start/012.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 13 of 20"
      },
      {
        "src": "/progress/whitstable-heights/01-pre-start/013.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 14 of 20"
      },
      {
        "src": "/progress/whitstable-heights/01-pre-start/014.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 15 of 20"
      },
      {
        "src": "/progress/whitstable-heights/01-pre-start/015.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 16 of 20"
      },
      {
        "src": "/progress/whitstable-heights/01-pre-start/016.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 17 of 20"
      },
      {
        "src": "/progress/whitstable-heights/01-pre-start/017.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 18 of 20"
      },
      {
        "src": "/progress/whitstable-heights/01-pre-start/018.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 19 of 20"
      },
      {
        "src": "/progress/whitstable-heights/01-pre-start/019.jpg",
        "type": "image",
        "alt": "Pre-Start, photo 20 of 20"
      }
    ]
  }
];
